module.exports = __webpack_public_path__ + "img/saeco.3b112907.png";